/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 6/23/15.
 */
'use strict';

function CollaboratorAddModalController(this: JS5Object, $routeParams: JS5Object, $filter: JS5Function, PaginationService: JS5Object,
                                        ModalService: JS5Object, CollaboratorsResourceFactory: JS5Object, CollaboratorsService: JS5Object,
                                        $location: JS5Object, DynamicPropertiesService: JS5Object, UtilsService: JS5Object) {
    const getCollaborators = () => {
        if (this.resolve.type === 'crew' || this.resolve.showContentCollaborators) {
            this.loadingIndicator.show = true;

            let offset = this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1);
            this.selectedRows = [];

            const queryOpts: JS5Object = {
                fetchOffset: offset,
                fetchLimit: this.pagingOptions.pageSize
            };

            if (this.searchText && this.searchText.length) {
                queryOpts.searchString = this.searchText;
            }

            const handleGridDataQuery = (collaborators: Array<JS5Object>, responseHeaders: JS5Function) => {
                PaginationService.parseResponseHeaders(responseHeaders());

                if (this.resolve.savedRoles) {
                    _.forEach(collaborators, (collaborator: JS5Object) => {
                        this.createRoleSelections(collaborator);
                    });
                }

                this.gridOptions.data = collaborators;
                this.originalData = angular.copy(collaborators);
                PaginationService.pageData = collaborators;
                this.loadingIndicator.show = false;
            };

            CollaboratorsService.getAllCollaborators(queryOpts, handleGridDataQuery);
        } else {
            this.gridOptions.data = this.resolve.collaborators;
            this.originalData = angular.copy(this.resolve.collaborators);
        }
    };

    this.saveNewCollab = (newCollab: JS5Object) => {
        if (this.resolve.showContentCollaborators) {
            CollaboratorsService.saveNewCollaborator(newCollab.collaborator).then((collaborator: JS5Object) => {
                let contentPathParam = (this.resolve.isSeries) ? 'series' : 'movies';
                const actor: JS5Object = {
                    type: 'Actor',
                    collaborator: collaborator,
                    contentId: $routeParams.id,
                    character: _.get(newCollab, 'collaborator.character')
                };
                CollaboratorsService.newActor = actor;
                if (_.isNil(_.get(newCollab, 'collaborator.character'))) {
                    $location.url(`/meta/${contentPathParam}/edit/${$routeParams.id}/actor/edit/-1`);
                } else {
                    CollaboratorsService.saveContentActor({id: $routeParams.id}, CollaboratorsService.newActor).then((data: JS5Object) => {
                        CollaboratorsService.originalEditData = angular.copy(data);
                        _.set(collaborator, 'character', _.get(newCollab, 'collaborator.character'));
                        CollaboratorsService.newActor = null;
                        this.close({$value: [collaborator]});
                    });
                }


            });
        } else {
            CollaboratorsService.saveNewCollaborator(_.get(newCollab, 'collaborator')).then((collaborator: JS5Object) => {
                let selectedRoles = _.toArray(_.get(newCollab, 'selectedRoles'));
                if (!_.isEmpty(selectedRoles)) {
                    collaborator.collaboratorRoleSelection = selectedRoles.map((role: JS5Object) => {
                        return {name: role};
                    });
                }
                this.close({$value: [collaborator]});
            });
        }
    };

    const checkToSaveNewCollaborator = (newCollabData: JS5Object) => {
        let newCollab = _.get(newCollabData, 'newCrewCollab');
        if (!_.isNil(newCollab)) {
            if (_.get(newCollabData, 'actorIsSelf')) {
                _.set(newCollab, 'collaborator.character', 'Self');
            }
            this.loadingIndicator.show = true;

            const criteria = {
                fetchOffset: 0,
                fetchLimit: 100,
                searchString: _.get(newCollab, 'collaborator.displayName')
            };

            CollaboratorsService.getAllCollaborators(criteria).then((collaborators: Array<JS5Object>) => {
                // CHeck if there is a collaborator in the system with the same name
                let alreadyExistingCollaborator = _.find(collaborators, (collab: JS5Object) => {
                    return _.isEqual(_.get(collab, 'displayName'), _.get(newCollab, 'collaborator.displayName'));
                });
                // if the collaborator already exists, prompt the user to overwrite it or to cancel
                if (!_.isNil(alreadyExistingCollaborator)) {
                    ModalService.showMessageModal({
                        messageText: 'A collaborator with this display name already exists in the system, would you like to continue to create a duplicate?',
                        title: 'Duplicate Collaborator Found',
                        showOK: true
                    }, () => {
                        this.saveNewCollab(newCollab);
                    }, () => {
                        this.loadingIndicator.show = false;
                        this.newCollaborator();
                    });
                } else {
                    this.saveNewCollab(newCollab);
                }
            });
        }
        else {
            this.newCollaborator();
        }
    };

    const onPaginationChanged = () => {
        getCollaborators();
    };

    const collaboratorRoleColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'package/editor/components/modals/collaborators/grid-checkbox-header-template.html'
        },
        {
            field: 'displayName',
            width: '40%',
            displayName: 'DisplayName',
            sort: {direction: 'asc', priority: 0},
            enableColumnMenu: false
        },
        {
            field: 'nickname',
            width: '20%',
            displayName: 'Nickname',
            enableColumnMenu: false
        },
        {
            field: 'iMDbNumber',
            enableColumnMenu: false,
            name: 'imdbColumn',
            displayName: 'IMDB#',
            width: '35%',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/hyperlink-template.html'
        }
    ];

    const actorColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'package/editor/components/modals/collaborators/grid-checkbox-header-template.html'
        },
        {
            field: 'collaborator.displayName',
            width: '40%',
            displayName: 'DisplayName',
            sort: {direction: 'asc', priority: 0},
            enableColumnMenu: false
        },
        {
            field: 'collaborator.nickname',
            width: '20%',
            displayName: 'Nickname',
            enableColumnMenu: false
        },
        {
            field: 'character',
            width: '35%',
            displayName: 'Character',
            enableColumnMenu: false
        }
    ];

    const crewColumns = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'package/editor/components/modals/collaborators/grid-checkbox-header-template.html'
        },
        {
            field: 'displayName',
            width: '46%',
            displayName: 'DisplayName',
            sort: {direction: 'asc', priority: 0},
            enableColumnMenu: false
        },
        {
            field: 'nickname',
            width: '24%',
            displayName: 'Nickname',
            enableColumnMenu: false
        },
        {
            field: 'collaboratorRoleDropdownElements',
            width: '26%',
            enableColumnMenu: false,
            displayName: 'Role',
            cellTemplate: 'package/editor/components/modals/collaborators/role-grid-cell-template.html'
        }
    ];

    this.searchText = '';
    this.selectedRows = [];
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        enableSelectAll: true,
        enableColumnMenu: false,
        multiSelect: this.resolve.allowMultiSelect,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.selection.on.rowSelectionChanged(null, this.gridRowSelectionChangedHandler);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
    };

    this.getAvailableRoles = () => {
        return DynamicPropertiesService.getPropValueAsList('package.crewMemberRoles');
    };

    this.createRoleSelections = (collab: JS5Object) => {
        let currentRoles = this.resolve.savedRoles[parseInt(collab.id)];
        let idSuffix = 0;
        collab.collaboratorRoleDropdownElements = [];
        angular.forEach(this.availableRoles, (availableRole) => {
            collab.collaboratorRoleDropdownElements.push({
                id: collab.displayName + idSuffix++,
                name: availableRole,
                disabled: !!(currentRoles && currentRoles.indexOf(availableRole) > -1)
            });
        });
    };

    this.toggleRows = (evt: JS5Object) => {
        if (this.gridApi.selection.selectAll) {
            this.gridApi.selection.clearSelectedRows(evt);
            this.gridApi.selection.selectAll = false;
        } else {
            this.gridApi.selection.selectAllVisibleRows(evt);
            this.gridApi.selection.selectAll = true;
        }

        this.selectedRows = this.gridApi.selection.getSelectedRows();
    };

    this.gridRowSelectionChangedHandler = (row: JS5Object) => {
        if (row.isSelected) {
            this.selectedRows.push(row.entity);
        } else {
            let index = this.selectedRows.indexOf(row.entity);
            this.selectedRows.splice(index, 1);
        }
    };

    this.executeSearch = (event: JS5Object) => {
        let canPerformSearchFromKeyCode = true;

        if (event) {
            canPerformSearchFromKeyCode = UtilsService.canPerformSearchFromKeyCode(event);
        }

        if (canPerformSearchFromKeyCode && (this.resolve.type === 'crew' || this.resolve.showContentCollaborators)) {
            getCollaborators();
        } else if (!this.resolve.showContentCollaborators) {
            let searchFields = ['character', 'collaborator.displayName', 'collaborator.nickName', 'collaborator.iMDbNumber'];
            this.gridOptions.data = $filter('gridSearch')(this.originalData, this.searchText, searchFields);
        }
    };

    this.disableOKButton = () => {
        return this.selectedRows.length === 0;
    };

    this.newCollaborator = () => {
        ModalService.showNewCrewCollaboratorModal(this.resolve.showContentCollaborators, checkToSaveNewCollaborator);
    };

    this.paginationPrevPageHandler = () => {
        --this.pagingOptions.currentPage;
        onPaginationChanged();
    };

    this.paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        onPaginationChanged();
    };

    this.paginationJumpToPageHandler = () => {
        onPaginationChanged();
    };

    this.showPaginationControls = () => this.resolve.type === 'crew' || this.resolve.showContentCollaborators;

    this.pageSizeChangeHandler = () => {
        onPaginationChanged();
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        if (this.resolve.type === 'actors') {
            if (this.resolve.showContentCollaborators) {
                this.gridOptions.columnDefs = collaboratorRoleColumns;
            } else {
                this.gridOptions.columnDefs = actorColumns;
            }
        } else {
            this.gridOptions.columnDefs = crewColumns;
        }

        this.pagingOptions = PaginationService;
        PaginationService.pageDataResource = CollaboratorsResourceFactory;
        this.loadingIndicator.show = true;
        DynamicPropertiesService.queryForProperties()
            .then(() => {
                this.availableRoles = this.getAvailableRoles();
                return getCollaborators();
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };
}

angular.module('prism-ui.package').component('collaboratorAddModal', {
    templateUrl: 'package/editor/components/modals/collaborators/collaborator-add-modal-template.html',
    controller: CollaboratorAddModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});
